import React, { useState, useEffect, useRef } from "react";
import Footer from "../layout/footerUpdated";
import Header from "../layout/headerHome";
import ServiceSectionLeft from "../element/component/ServiceSectionPhysioLeft";
import ServiceSectionRight from "../element/component/ServiceSectionPhysioRight";
import FAQComponent from '../element/component/faq';
import WhyLab from '../element/component/why';
import TestimonialSlider from "../element/component/testimonial-slider";
import ReachToUsForm from "../element/ReachToUsForm";
import Popup_Main from "../element/component/Popup_Main";

const Physiotherapy = () => {

    const [activeTab, setActiveTab] = useState("jpnagar");
    const [isOpen, setIsOpen] = useState(false);
    const [activeIndex, setActiveIndex] = useState(0);

    const toggleAccordion = (index) => {
      setActiveIndex(activeIndex === index ? null : index);
    };
  
    const options = [
      {
        title: "One-on-One Physiotherapy",
        content: "Personalised in-clinic sessions built around your condition and recovery goals."
      },
      {
        title: "Group Physiotherapy",
        content: "Guided group sessions focused on movement, mobility and functional strength."
      },
      {
        title: "At-Home Physiotherapy",
        content: "Personalised physiotherapy delivered in the comfort of your home."
      },
      {
        title: "Online Physiotherapy",
        content: "Virtual guidance, exercise progression and follow-up wherever you are."
      },
    ];

  const Counter = ({ targetValue, duration }) => {
    const [count, setCount] = useState(0);
    const [isAnimating, setIsAnimating] = useState(false);
  
    useEffect(() => {
      let startValue = 0;
      const increment = targetValue / (duration / 50);
  
      const updateCounter = () => {
        startValue += increment;
        if (startValue >= targetValue) {
          setCount(Math.ceil(targetValue));
          setIsAnimating(false); // End animation
        } else {
          setCount(Math.floor(startValue));
          setIsAnimating(true); // Start animation
          requestAnimationFrame(updateCounter);
        }
      };
  
      setIsAnimating(true); // Initialize animation
      updateCounter();
    }, [targetValue, duration]);
  
    return <h3 className={isAnimating ? "animate-counter" : ""}>{count}%</h3>;
  };
  
  const whyData = [
    { title: "Certified and Experienced Physiotherapists", image: "/images/new-website/physiotherapy/physiotherapist.webp" },
    { title: "Tailored Treatment Plans", image: "/images/new-website/yoga/personalized-treatment.webp" },
    { title: "Holistic Approach", image: "/images/new-website/yoga/comprehensive-holistic-approach.webp" },
    { title: "Wide Range of Care", image: "/images/new-website/physiotherapy/wide-range-care.webp" },
    { title: "Flexible Schedules, Affordable Plans", image: "/images/new-website/yoga/flexible-schedule.png" },
    { title: "State-of-the-Art Equipment", image: "/images/new-website/physiotherapy/physio-equipments.webp" },
];

    const yogaTypes = [
        {
            name: "Pain & Musculoskeletal Physiotherapy",
            desc: "Targeted care for neck, shoulder, back and joint pain to improve movement and everyday function.",
            image: "/images/new-website/physiotherapy/musculoskeletal-pain.webp",
          },
          {
            name: "Post-Surgical & Joint Replacement Rehabilitation",
            desc: "Structured rehabilitation after surgery, including hip and knee replacement, to rebuild strength and mobility.",
            image: "/images/new-website/physiotherapy/joint-replacement-surgery.webp",
          },
          {
            name: "Sports Injury Rehabilitation",
            desc: "Specialised physiotherapy to support injury recovery, restore movement and help you return safely to activity.",
            image: "/images/new-website/physiotherapy/sports-ankle-physio.webp",
          },
          {
            name: "Neuro & Post-Paralysis Rehabilitation",
            desc: "Personalised rehabilitation for neurological conditions and post-paralysis recovery to improve movement, balance and independence.",
            image: "/images/new-website/physiotherapy/post-paralysis-physio.webp",
          },
          {
            name: "Women’s Health Physiotherapy",
            desc: "Specialised physiotherapy addressing women’s mobility, pelvic health and physical needs across different life stages.",
            image: "/images/new-website/physiotherapy/women-pelvic-repair.webp",
          },
          {
            name: "Geriatric Physiotherapy",
            desc: "Senior-focused care to improve strength, balance, mobility and confidence in everyday movement.",
            image: "/images/new-website/physiotherapy/geriatric-senior-physio.webp",
          },
          {
            name: "Ergonomic & Posture Physiotherapy",
            desc: "Assessment and corrective exercises to address posture, workplace strain and movement-related discomfort.",
            image: "/images/new-website/physiotherapy/ergonomics-physio.webp",
          },
           {
            name: "Chronic Condition Management",
            desc: "Ongoing physiotherapy to maintain mobility, strength and functional independence while managing long-term health conditions.",
            image: "/images/new-website/physiotherapy/chronic-condition-physio.webp",
          },
    
      ];

  const testimonials = [
    {
      content:
        "Bridge health offers services at affordable cost. Akshata at the front desk is very cooperative and good at coordinating and follow-ups. The staff are well spoken and carried out all tests with patience.",
      name: "Akshata J Lokhande",
      image: "/images/new-website/bridgehealth-icon-new.webp", // Replace with actual image URL
    },
    {
      content:
        "I am Prof Sundararaj living at PRIMUS REFLECTION. The staff are very courteous with a smile on their faces, including all the doctors. Special thanks to Ms. Akshita!",
      name: "Sundar Raj",
      image: "/images/new-website/bridgehealth-icon-new.webp", // Replace with actual image URL
    },
    {
      content:
        "Good , clean hygiene place ... Feels like your are at home with the services that provide... I have enrolled for gym here.. And the trainers are thorough professionals.. And the staff I have interacted with them during the seminars or presentations they are knowledgeable",
      name: "Shiva Kumar S",
      image: "/images/new-website/bridgehealth-icon-new.webp", // Replace with actual image URL
    },
    {
      content:
        "From sattva apartment Bridge healthy is useful for our patients.Mahendra the nursing staff is good and courteous.",
      name: "Susheela Sharan",
      image: "/images/new-website/bridgehealth-icon-new.webp", // Replace with actual image URL
    },
    {
      content:
        "Laxman is an excellent nurse looking after the retired community. Gentle in taking blood. Very polite and efficient.",
      name: "Dipak Rao",
      image: "/images/new-website/bridgehealth-icon-new.webp", // Replace with actual image URL
    },
  ];

  const faqs = [
    {
      question: "What are the benefits of physiotherapy? ",
      answer:
        "Benefits of Physiotherapy are: It helps reduce pain, improve mobility, strengthen muscles, and restore functional independence after injury or surgery. ",
    },
    {
      question: "Does Bridge Health provide home services for physiotherapy? ",
      answer: "Yes, we provide home services for physiotherapy, and group therapy sessions, both offline and online. ",
    },
    {
      question: "What types of physiotherapy services does Bridge Health offer in Bangalore?",
      answer: "Bridge Health offers services like pain management, post-surgical rehabilitation, sports injury recovery, physiotherapy for chronic conditions, dry needling, posture & gait training, exercise therapy and a whole lot more for pregnant women and the elderly. ",
    },
    {
      question: "Does Bridge Health offer physiotherapy for elderly patients in Bangalore? ",
      answer: "Yes, Bridge Health provides specialised physiotherapy services tailored for elderly patients to improve mobility, strength, and quality of life, and prevent falls.",
    },
    {
      question: "What are the costs of physiotherapy sessions at Bridge Health in Bangalore? ",
      answer: "The cost of physiotherapy sessions at Bridge Health varies depending on the type of therapy and duration; detailed pricing is available upon consultation",
    },
  ];


  const [isMobile, setIsMobile] = useState(false);
  const sectionRefs = useRef([]); // Refs for multiple sections/cards
  const [hasAnimated, setHasAnimated] = useState([]); // Animation tracking for cards

  // Resize event listener to detect mobile view
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    handleResize(); // Initialize on mount
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Scroll Animation Logic
  useEffect(() => {
    const handleScroll = () => {
      const updatedVisibility = sectionRefs.current.map((ref) => {
        if (ref) {
          const rect = ref.getBoundingClientRect();
          const windowHeight =
            window.innerHeight || document.documentElement.clientHeight;

          // Element becomes visible when its top is within viewport
          return rect.top <= windowHeight - 50;
        }
        return false;
      });

      setHasAnimated((prev) =>
        updatedVisibility.map((visible, index) => prev[index] || visible)
      );
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll(); // Trigger on mount to check initial visibility
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const cardsData = [
    { title: "Neck and Shoulder Pain ", image: "/images/new-website/physiotherapy/neck.webp" },
    { title: "Back Pain and Slip Disc ", image: "/images/new-website/physiotherapy/back-neuro.webp" },
    { title: "Exercises for Women’s Health ", image: "/images/new-website/physiotherapy/prenatal-care.webp" },
    { title: "Ergonomic Exercises ", image: "/images/new-website/physiotherapy/computer-desktop.webp" },
  ];

  const cardsDataRight = [
    { title: "Post –Paralysis & Rehabilitation ", image: "/images/new-website/physiotherapy/technology-1.webp" },
    { title: "Neuro Physiotherapy ", image: "/images/new-website/physiotherapy/chiropractic.webp" },
    { title: "Hip & Knee Replacement Rehabilitation ", image: "/images/new-website/physiotherapy/broken-bone.webp" },
    { title: "Geriatric Physiotherapy ", image: "/images/new-website/physiotherapy/technology.webp" },
  ];


  return (
    <div>
      <Header/>
      <div className={`landingcontainer-physio ${isMobile ? "mobile" : ""}`}>
        <div className={`leftContainerphysio ${isMobile ? "mobile" : ""}`}>
          <h1>
            <span className="highlight1">Expert Physiotherapy</span> for Pain Relief, Recovery & Better Movement
          </h1>
          <p className="paragraph">Personalised physiotherapy for pain, injuries, post-surgical rehabilitation, women’s health and mobility—available in-clinic, at home and online.</p>
          <button className="buttonlanding" onClick={()=>setIsOpen(true)}>Book a Physiotherapy Consultation</button>
        </div>
        <div className="rightContainerphysio">
          <img
            src="/images/new-website/physiotherapy/bh-physio-banner.webp"
            alt="physio-landing"
            className="physiolanding imageFadeInUp"
          />
        </div>
      </div>
      
      {/* <section>
            <div style={{marginTop:"50px"}} className="rightstrongcontainer">
            <h2 className="heading1">
            Explore
              <span className="highlight1"> Expert Therapies </span>
              <span className="line-break-heading"></span>  for A Wide Range of Conditions
            </h2>
            <p style={{textAlign:"center"}}>Individual therapies crafted to take care of all your health needs. </p>
                    <div className="physio-service">
                    <ServiceSectionLeft
                            cardsData={cardsData}
                            isMobile={isMobile}
                            highlight="For All Your Health Needs"
                            heading="Personalised Offline & Online Yoga Classes"
                            customClass="WellnessSectionWomen"
                    />
                    <div className="skeleton-container">
                            <div className="hover-area" data-target="neck"></div>
                            <div className="hover-area" data-target="back"></div>
                            <div className="hover-area" data-target="post-paralysis"></div>
                            <div className="hover-area" data-target="neuro"></div>
                            <div className="hover-area" data-target="hip-knee"></div>
                            <img
                            src="/images/new-website/physiotherapy/skeleton.webp"
                            alt="Skeleton"
                            className="physio-skeleton"
                            />
                        </div>
                    <ServiceSectionRight
                        cardsDataRight={cardsDataRight}
                        isMobile={isMobile}
                        highlight="For All Your Health Needs"
                        heading="Personalised Offline & Online Yoga Classes"
                        customClass="WellnessSectionWomen"
                    />
              </div>
              <div className="service-section-button">
                <button className="buttonlanding" onClick={()=>setIsOpen(true)}>Request a Call Back</button>
              </div>
              </div>
      </section> */}
            
      <section>
        <div className="yoga-types">
          <div className="rightstrongcontainer">
            <h2 className="heading1">
              <span className="highlight1"> Individual Therapies</span> Crafted to Care For All Your Health Needs
            </h2>
            <p className="physio-text">Physiotherapy at Bridge Health combines personalised assessment, hands-on treatment and guided exercise to help relieve pain, restore movement and rebuild strength. Our physiotherapists support musculoskeletal concerns, sports injuries, post-surgical rehabilitation, women’s health and age-related mobility needs, with care available in-clinic, at home and online.</p>

          </div>
          <div className="yoga-type-card-section">
                {yogaTypes.map((yoga, index) => (
                    <div
                    key={index}
                    className="physio-type-card"
                    >
                    <img src={yoga.image} alt={yoga.name} className="leadership-image" />
                    <div className="physio-types-desc">
                    <h3 className="solutiontext"><span className="solutionbold">{yoga.name.split(" ")[0]}</span>{" "}
                    {yoga.name.split(" ").slice(1).join(" ")}</h3>
                    <p className="yoga-type-desc">{yoga.desc}</p>
                    </div>
                    </div>
                ))}
          </div>
        </div>
      </section>

      <section>
        <div className="physio-options">
          <div className="physio-options-container">
            <h2>
            How Would You Like to Receive
              <span className="highlight1"> Physiotherapy?</span>
            </h2>
            <p>Choose the way that works best for you—from one-on-one and group sessions at our clinics to physiotherapy at home or online, all guided by experienced physiotherapists.</p>
            
            <button className="buttonmaphome" onClick={()=>setIsOpen(true)}>Book a Physiotherapy Consultation</button>

          </div>
          <div className="physio-option-right">
            <div className="accordion-container">
                {options.map((option, index) => (
                    <div key={index} className="accordion-item">
                    <button
                        className={`accordion-title-new ${activeIndex === index ? "active" : ""}`}
                        onClick={() => toggleAccordion(index)}
                    >
                        {option.title}
                        <span className={`chevron-icon ${activeIndex === index ? "rotate" : ""}`}>
                          {activeIndex === index ? "▲" : "▼"}
                        </span>
                    </button>
                    {activeIndex === index && (
                        <div className="accordion-content-desc">
                        {option.content}
                        </div>
                    )}
                    </div>
                ))}
            </div>
          </div>
        </div>
      </section>

      <div className="bridge-health-app"> 
            <div className="bridge-health-sidebar-physio">
            <h2>Let’s Walk Through Bridge Health’s <span className="highlight1"> Physiotherapy Clinics</span> in JP Nagar, Bangalore</h2>
                <div className="care-center-desk-physio">
                <button className="buttonmaphome" onClick={()=>setIsOpen(true)}>Book a Physiotherapy Consultation</button>
                </div>
            </div>
            <div className="bridge-health-content">
                 <div className="youtube-short-wrapper">
                    <iframe
                      src={`https://www.youtube-nocookie.com/embed/Pasrh3uGN58?autoplay=0&mute=0&controls=0&loop=1&playlist=Pasrh3uGN58&rel=0&modestbranding=1&playsinline=1`}
                      title="Bridge Health Physiotherapy Clinic"
                      loading="lazy"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                      allowFullScreen
                    ></iframe>
                  </div>
            </div>
      </div>

      <section className="why-choose-section-physio">
          <h2 className="heading1">Why Choose <span className="highlight1">Bridge Health</span> for Physiotherapy</h2>
                    
          <WhyLab
            whyData={whyData} 
            dynamicText="Radiology" 
            dynamicParagraph="We have some of the best specialists who bring years of experience and offer evidence – based treatment to ensure best care for you" 
          />
      </section>

     <section>
        <div>
        <FAQComponent faqs={faqs} />
        </div>
     </section>

    <section>
    <div className="testimonials-container">
      {/* Left Side */}
      <div className="left-section-testimonial">
        <h2>
        Trust Us Based on What Our <span className="highlight1">Patrons Say</span>
        </h2>
        <h3>Overall Ratings</h3>
        <div className="ratings">
          <img
            src="/images/new-website/women-care/google-logo-1.webp"
            alt="Google Logo"
          />
          <div>
            <p>
              4.9{" "}
              <span className="stars">
                ⭐⭐⭐⭐⭐
              </span>
            </p>
            <p>Customer Reviews</p>
          </div>
        </div>
        <a href="https://g.page/r/CagLkxSu4CfZEAE/review" target="_blank" rel="noopener noreferrer">
        <button className="buttonmaphome-review">Write a Review</button>
        </a>
      </div>

      {/* Right Side */}
      <div className="right-section-testimonial">
        <div className="testimonial-page">
      <TestimonialSlider testimonials={testimonials} />
    </div>
      </div>
    </div>
    </section>
    <Popup_Main isOpen={isOpen} onClose={() => setIsOpen(false)} >
        <ReachToUsForm submitted={() => setIsOpen(false)} />
        </Popup_Main>
        <Footer />
    </div>
  );
};

export default Physiotherapy;
